module.exports = __webpack_public_path__ + "static/media/jkcard.c66d1431.png";